export default "__VITE_ASSET__Js8nmo6___"